const styles = {
  container: {
    // border: "1px solid green",
    // minWidth: "50%",
    // mx: "10rem",
  },
};

export default styles;
